// Chakra imports
import {
    Flex,
    Stat,
    StatLabel,
    StatNumber,
    useColorModeValue,
    Text,
    Icon,
    Tooltip,
} from "@chakra-ui/react";
// Custom components
import Card from "components/card/Card.js";
// Custom icons
import React from "react";
import { MdWarning } from "react-icons/md";
import { useTranslation } from "react-i18next";

export default function Default(props) {
    const { i18n } = useTranslation();
    const isRo = i18n.language === "ro";
    const {startContent, endContent, name, growth, value, period, roasTime, warning} = props;
    const textColor = useColorModeValue("secondaryGray.900", "white");
    const textColorSecondary = "secondaryGray.600";

    const formatPeriod = (periodValue) => {
        if (!periodValue) return "";
        if (!isRo) return periodValue;

        const map = {
            yesterday: "ieri",
            "the day before yesterday": "alaltaieri",
            "last week": "saptamana trecuta",
            "the week before last week": "saptamana de dinaintea celei trecute",
            "last month": "luna trecuta",
            "the month before last month": "luna de dinaintea celei trecute",
            "last year": "anul trecut",
            "the year before last year": "anul de dinaintea anului trecut",
        };

        return map[periodValue] || periodValue;
    };

    const displayPeriod = formatPeriod(period);

    return (
        <Card py='15px'>
            {warning && (
                <Tooltip label={warning} placement="top" hasArrow zIndex="tooltip">
                    <Flex
                        position="absolute"
                        top="8px"
                        right="12px"
                        zIndex="1"
                        boxSize="28px"
                        align="center"
                        justify="center"
                        cursor="help"
                    >
                        <Icon as={MdWarning} color="orange.400" w="18px" h="18px" />
                    </Flex>
                </Tooltip>
            )}
            {roasTime && !warning && (
                <Text
                    position="absolute"
                    top="15px"
                    right="20px"
                    fontSize="xs"
                    color={textColorSecondary}
                >
                    {roasTime}
                </Text>
            )}
            <Flex
                my='auto'
                h='100%'
                align={"center"}
                justify={{base: "center", xl: "center"}}>
                {startContent}

                <Stat my='auto' ms={startContent ? "18px" : "0px"}>
                    <StatLabel
                        lineHeight='100%'
                        color={textColorSecondary}
                        fontSize={{
                            base: "sm",
                        }}>
                        {name}
                    </StatLabel>
                    <StatNumber
                        color={textColor}
                        fontSize={{
                            base: "2xl",
                        }}>
                        {value}
                    </StatNumber>
                    {growth ? (
                        <Flex align='center'>
                            <Text
                                color={parseFloat(growth) > 0 ? 'green.500' : 'red.500'}
                                fontSize='xs'
                                fontWeight='700'
                                me='5px'
                            >
                                {parseFloat(growth).toFixed(0)}%
                            </Text>
                            {displayPeriod && <Text color='secondaryGray.600' fontSize='xs' fontWeight='400'>
                                {isRo ? 'fata de' : 'since'} {displayPeriod}
                            </Text>}
                        </Flex>
                    ) : <Text
                        color={'secondaryGray.600'}
                        fontSize='xs'
                        fontWeight='700'
                        me='5px'
                    >
                        {displayPeriod ? `${isRo ? 'la fel ca' : 'same as'} ${displayPeriod}` : null}
                    </Text>
                    }
                </Stat>
                <Flex ms='auto' w='max-content'>
                    {endContent}
                </Flex>
            </Flex>
        </Card>
    );
}
